var Backbone, EmailFormV2FlexibleContactChannelsTextView, SupportV2FlexibleContactChannelsTemplate,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportV2FlexibleContactChannelsTemplate = require('../../../../v2_flexible_contact_channels.html.mustache');

Backbone = require('backbone');

Backbone.$ = $;

EmailFormV2FlexibleContactChannelsTextView = (function(superClass) {
  extend(EmailFormV2FlexibleContactChannelsTextView, superClass);

  function EmailFormV2FlexibleContactChannelsTextView() {
    return EmailFormV2FlexibleContactChannelsTextView.__super__.constructor.apply(this, arguments);
  }

  EmailFormV2FlexibleContactChannelsTextView.prototype.className = 'flexible-contact-channels-text-view';

  EmailFormV2FlexibleContactChannelsTextView.prototype.events = {
    'DOMSubtreeModified .primary-chat-link#live-chat-link-container': 'handleDisplayOfPrimaryLiveChatLink',
    'DOMSubtreeModified .secondary-chat-link#live-chat-link-container': 'handleDisplayOfSecondaryLiveChatLink',
    'DOMSubtreeModified .tertiary-chat-link#live-chat-link-container': 'handleDisplayOfTertiaryLiveChatLink',
    'click .flex-email-link': 'renderEmailForm',
    'click .flex-phone-link': 'renderPhoneView',
    'click .flex-chat-link': 'renderChatClickView'
  };

  EmailFormV2FlexibleContactChannelsTextView.prototype.initialize = function(options) {
    this.options = options || {};
    _.bindAll.apply(_, [this].concat(_.functions(this)));
    this.I18nScope = 'modules.support';
    this.template = SupportV2FlexibleContactChannelsTemplate;
    this.model = Groupon.Support.FlexibleContactChannelModel;
    return this.mainView = this.options.mainView;
  };

  EmailFormV2FlexibleContactChannelsTextView.prototype.render = function() {
    var options;
    this.model.presentContactChannels();
    this.$el.empty();
    options = {
      withoutChat: !this.isLiveChatEnabled(),
      renderLayout: true
    };
    this.$el.html(this.arrangeLayoutView(this.toHash(options)));
    return this;
  };

  EmailFormV2FlexibleContactChannelsTextView.prototype.isLiveChatEnabled = function() {
    return Groupon.Support.LiveChatModel.isLiveChatEnabled();
  };

  EmailFormV2FlexibleContactChannelsTextView.prototype.renderEmailForm = function(e) {
    return this.mainView.renderEmailForm();
  };

  EmailFormV2FlexibleContactChannelsTextView.prototype.renderPhoneView = function() {
    return this.mainView.renderPhoneNumberView();
  };

  EmailFormV2FlexibleContactChannelsTextView.prototype.renderChatClickView = function() {
    return this.mainView.renderChatClickView();
  };

  EmailFormV2FlexibleContactChannelsTextView.prototype.handleDisplayOfPrimaryLiveChatLink = function() {
    var primaryChatTextElem;
    primaryChatTextElem = $(".flex-chat-channel-text");
    this.toggleDomElemsBasedOnLiveChat(primaryChatTextElem);
    this.$el.find('.flex-contact-channels-without-chat').empty();
    if (window.liveChatLinkVisible()) {
      window.showDOMElems($('.help-wizard-content > .flexible-contact-channels-container'));
      return window.hideDOMElems($('.flex-contact-channels-without-chat'));
    } else {
      window.hideDOMElems($('.help-wizard-content > .flexible-contact-channels-container'));
      window.showDOMElems($('.flex-contact-channels-without-chat'));
      return $('.flex-contact-channels-without-chat').html(this.arrangeLayoutView(this.toHash({
        withoutChat: true
      })));
    }
  };

  EmailFormV2FlexibleContactChannelsTextView.prototype.handleDisplayOfSecondaryLiveChatLink = function() {
    var DOMelemsToToggle, flexTertiaryOrTextElem, secondaryFlexibleLiveChatContainerElem;
    secondaryFlexibleLiveChatContainerElem = $('.secondary-flex-chat-channel');
    flexTertiaryOrTextElem = $('.flex-channel-or-text');
    DOMelemsToToggle = [secondaryFlexibleLiveChatContainerElem, flexTertiaryOrTextElem];
    if (this.model.get('formattedContactChannels').contact_channels.length === 2) {
      DOMelemsToToggle.push($('.flex-secondary-channel-also-text'));
    }
    return this.toggleDomElemsBasedOnLiveChat(DOMelemsToToggle);
  };

  EmailFormV2FlexibleContactChannelsTextView.prototype.handleDisplayOfTertiaryLiveChatLink = function() {
    var flexTertiaryOrTextElem, tertiaryFlexibleLiveChatContainerElem;
    tertiaryFlexibleLiveChatContainerElem = $('.tertiary-flex-chat-channel');
    flexTertiaryOrTextElem = $('.flex-channel-or-text');
    return this.toggleDomElemsBasedOnLiveChat([tertiaryFlexibleLiveChatContainerElem, flexTertiaryOrTextElem]);
  };

  EmailFormV2FlexibleContactChannelsTextView.prototype.toggleDomElemsBasedOnLiveChat = function(domElems) {
    if (window.liveChatLinkVisible()) {
      return window.showDOMElemsInline(domElems);
    } else {
      window.removeDOMElemsInline(domElems);
      return window.hideDOMElems(domElems);
    }
  };

  EmailFormV2FlexibleContactChannelsTextView.prototype.toHash = function(arg) {
    var additionalInfo, contactChannelhash, hash, renderLayout, withoutChat;
    withoutChat = arg.withoutChat, renderLayout = arg.renderLayout;
    contactChannelhash = {};
    if (withoutChat) {
      contactChannelhash = this.model.get('contactChannelsWithoutBoldChat');
    } else if (this.model.has('formattedContactChannels')) {
      contactChannelhash = this.model.get('formattedContactChannels');
    } else {
      contactChannelhash = this.model.get('contactChannelsWithoutBoldChat');
    }
    if (window.evaluate(this.options.shouldShowCallBackFailureView)) {
      contactChannelhash = this.model.getContactChannelsForCallBack(contactChannelhash);
    }
    additionalInfo = {
      isVertical: window.evaluate(this.options.isVertical),
      shouldShowCallBackFailureView: window.evaluate(this.options.shouldShowCallBackFailureView)
    };
    if (renderLayout) {
      additionalInfo.renderLayout = true;
    }
    hash = $.extend(true, additionalInfo, contactChannelhash);
    return hash;
  };

  EmailFormV2FlexibleContactChannelsTextView.prototype.arrangeLayoutView = function(hash) {
    var $html, html;
    html = toHtml(this.template, hash, this.I18nScope);
    $html = $(html);
    $html.find('.flexible-contact-channel-icon-container').hide();
    $html.find('.recommended').hide();
    if (window.evaluate(this.options.shouldShowCallBackFailureView)) {
      $html.find('.flex-primary-channel-text').hide();
      $html.find('.contact-options').hide();
      $html.find('.contact-channels-v2-header').hide();
    }
    return $html;
  };

  EmailFormV2FlexibleContactChannelsTextView.prototype.renderLiveChat = function() {
    if (this.model.get('liveChatExists')) {
      if (this.model.get("primaryChannelIsBoldChat")) {
        this.mainView.renderLiveChat({
          liveChatMode: 'static',
          liveChatType: Groupon.Support.LiveChatModel.getFlexibleV2LiveChatType()
        });
      }
      return this.mainView.renderLiveChat({
        liveChatMode: 'static',
        liveChatType: Groupon.Support.LiveChatModel.getLinkLiveChatType(),
        startFromSameViewState: this.model.get("primaryChannelIsBoldChat")
      });
    }
  };

  return EmailFormV2FlexibleContactChannelsTextView;

})(Backbone.View);

module.exports = EmailFormV2FlexibleContactChannelsTextView;

//# sourceMappingURL=data:application/json;base64,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
